module.exports = __webpack_public_path__ + "media/logos/kroger-31600fc2.png";